import { Fragment } from "react";
import { Link } from "react-router-dom";
const PageNotFound = () => {
    return ( 
    <Fragment>
       <div className="flex flex-col items-center justify-center min-h-screen p-6 text-center bg-white">
         {/* Visual Element: A Stylized 404 */}
         <div className="relative">
           <h1 className="text-[12rem] font-black text-gray-100 leading-none select-none">
             404
           </h1>
           <p className="absolute inset-0 flex items-center justify-center mt-8 text-3xl font-bold text-gray-900">
             Page Not Found
           </p>
         </div>
   
         {/* Message */}
         <div className="max-w-md mt-4">
           <h2 className="mb-2 text-xl font-semibold text-gray-800">
             Oops! You've drifted into space.
           </h2>
           <p className="mb-8 text-gray-500">
             The page you are looking for doesn't exist or has been moved. 
             Let's get you back to the field to find more about new world surveyor.
           </p>
         </div>
   
         {/* Action Buttons */}
         <div className="flex flex-col gap-4 sm:flex-row">
           <Link
             to="/"
             className="px-8 py-3 font-bold text-white transition-all duration-200 bg-blue-600 shadow-lg rounded-xl shadow-blue-200 hover:bg-blue-700 hover:-translate-y-1"
           >
             Return to Home
           </Link>
           
           <button 
             onClick={() => window.history.back()}
             className="px-8 py-3 font-bold text-gray-700 transition-all duration-200 bg-gray-100 rounded-xl hover:bg-gray-200"
           >
             Go Back
           </button>
         </div>
   
         {/* Footer Branding */}
         <div className="mt-16 text-sm font-medium tracking-widest text-gray-400 uppercase">
           New World Surveyor
         </div>
       </div>
    </Fragment> 
    );
}
 
export default PageNotFound;